module.exports = __webpack_public_path__ + "img/SL-M-160-210.a029928a.svg";